import request from "@/utils/request";

export function GetCoreTechnologes(nameInfo){
    return request({   
    url:`/coretechnology/getcoretechnologies?name=${nameInfo}`,
    method: 'get',
  })
}

export function OperateCoretechnology(formData) {  
  return request({
    url: '/coretechnology/operatecoretechnology', 
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data' // 重要：必须设置这个请求头
    }
  })
}

export function getcoretechnologymodes(formInf) {
  const data = {
    //id: formInf.id,
    name: formInf.name,
    technologyId: formInf.technologyId,    
  }; 
  // console.log(data);
  return request({
    url: "/coretechnology/getcoretechnologymodes",
    method: "post",
    data,
  });
}

export function OperateCoretechnologymode(formData) {  
  return request({
    url: '/coretechnology/operatecoretechnologymode', 
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data' // 重要：必须设置这个请求头
    }
  })
}

export function getcoretechnologydetails(formInf) {
  const data = {
    //id: formInf.id,
    name: formInf.name,
    technologyId: formInf.technologyId,
    technologyModeId:formInf.technologyModeId,
  }; 
  // console.log(data);
  return request({
    url: "/coretechnology/getcoretechnologydetails",
    method: "post",
    data,
  });
}

export function OperateCoretechnologydetail(formData) {  
  return request({
    url: '/coretechnology/operatecoretechnologydetail', 
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data' // 重要：必须设置这个请求头
    }
  })
}